export default __webpack_public_path__ + "static/media/left-gray.9cc70ce1.svg";